// ========== CaregiversPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';
import AdUnit from '../components/AdUnit';
import AdRotator from '../components/AdRotator';

const CaregiversPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>
      {/* Place the AdUnit adsense component here */}
      <section className="headerAd">
        <AdRotator floating={true} placement="sidebar" />
       {/* <AdUnit adSlot="8074484061" /> */}
      </section>
      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1> Caregiver Insights</h1>
          <p>Guiding Futures with Data-Driven Probability</p>
        </div>

        <div className="content-section">
          <p>As a parent, custodian, or adult supervisor, you constantly strive to nurture and protect young people. Our AI model offers a revolutionary tool for proactive, informed caregiving by tapping into the collective wisdom of thousands of life journeys.</p>
        </div>

        <div className="content-section">
          <h2> Unlock Proactive Well-being</h2>
          <p>Traditional parenting relies on intuition and experience. Our AI moves beyond guesswork by analyzing vast datasets of real-life events:</p>
          <ul>
            <li>Calculate probability of academic trajectories</li>
            <li>Identify leadership potential based on current activities</li>
            <li>Assess statistical risk for future adverse outcomes</li>
          </ul>
          <p style={{marginTop: '1rem'}}><strong>Be proactive, not reactive</strong>, in guiding your loved ones.</p>
        </div>

        <div className="content-section">
          <h2> Targeted Insights from Life Events</h2>
          <p>Input events crucial to development:</p>
          <ul>
            <li><strong>Academic:</strong> GPA changes, tutoring programs, AP courses</li>
            <li><strong>Social:</strong> Volunteer roles, disciplinary actions, club memberships</li>
            <li><strong>Health:</strong> Chronic conditions, physical activity, lifestyle changes</li>
          </ul>
        </div>

        <div className="content-section">
          <h2> The Interventional Philosophy</h2>
          <p style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '1rem'}}>Our AI does not predict destiny; it reveals probability.</p>
          <p>If our model calculates a high probability for a less desirable outcome, this is not a fixed sentence�it's an early statistical alert. This is your most powerful tool.</p>
          <p style={{marginTop: '1.5rem', fontStyle: 'italic'}}>The probability is a map; you hold the steering wheel. Understanding the statistical landscape lets you actively change the sequence of events and shape their future.</p>
        </div>

        <div className="cta-section">
          <p>Empower your caregiving with data. Shape their tomorrow.</p>
          <button className="btn-primary" onClick={() => navigate('/login')}>Start Guiding Their Future</button>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default CaregiversPage;
